import { useParams } from 'react-router-dom'

import { EquipmentDataTable } from 'modules/job_catalog/components/EquipmentDataTable'
import { getChildNodeType, normalizeNodeType } from 'modules/job_catalog/lib/nodesUtils'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

export const ItManagementPage = () => {
  const { rootId, familyId, functionId, roleId, levelId } = useParams()
  const id = levelId || roleId || functionId || familyId || rootId || ''
  const childType = getChildNodeType(id)
  const nodeType = normalizeNodeType(id)

  return (
    <ResponsivePage.Body variant="full">
      {!!id && <EquipmentDataTable nodeId={id} nodeType={nodeType} childType={childType} />}
    </ResponsivePage.Body>
  )
}
